import { createClient } from '@supabase/supabase-js';

// Em producao, as chamadas batem em {origin}/sb/* e o Vercel faz rewrite
// server-side pro projeto Supabase. Isso contorna bloqueios de rede/DNS/
// extensoes que afetam *.supabase.co nos navegadores dos colaboradores.
// Em dev (Vite), nao ha proxy — usa a URL direta de VITE_SUPABASE_URL.
const supabaseUrl = import.meta.env.PROD
    ? `${window.location.origin}/sb`
    : import.meta.env.VITE_SUPABASE_URL;

const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// NÃO reintroduzir um client com service_role aqui.
//
// Existia um `supabaseAdmin` lendo VITE_SUPABASE_SERVICE_KEY, justificado por "desk é ferramenta
// interna, então service key no client é aceitável". A premissa não se sustenta: TODA variável
// VITE_* é embutida no bundle por design, e a service_role ignora RLS. Bastaria alguém abrir o
// DevTools — colaborador atual, ex-colaborador, máquina compartilhada, extensão de navegador —
// para extrair acesso total e permanente ao banco, que sobrevive à remoção do login da pessoa.
//
// Na prática o client estava morto: nenhuma chamada `supabaseAdmin.*` no projeto, e a variável
// nunca foi configurada em produção (só existia em .env.local de dev). Removido em 2026-08-05,
// junto com a service_role que estava hardcoded em services/squads.js — essa sim ia para o
// bundle publicado.
//
// Operação que precise ignorar RLS deve rodar no servidor (cron/rota do dashboard-orbion) ou
// virar policy no Supabase, nunca uma chave privilegiada entregue ao navegador.
